import jsCookie from 'js-cookie';

const hasConsent = jsCookie.get('hasConsent') === 'true';

window.hasConsent = hasConsent;
